import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EFeaturedProductSortField,
  IFeaturedProduct,
  PFeaturedProductFilter,
} from "src/core/featuredProduct/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IFeaturedProductState {
  featuredProducts: IFeaturedProduct[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IFeaturedProductState = {
  featuredProducts: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "featured-product/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "featured-product/FETCH_SUCCEEDED";
const FETCH_FAILED = "featured-product/FETCH_FAILED";
const POLLING_START_REQUESTED = "featured-product/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "featured-product/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IFeaturedProduct[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PFeaturedProductFilter;
    pagination: IPagination;
    sorts: ISort<EFeaturedProductSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IFeaturedProductState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IFeaturedProductState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.featuredProducts = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
